import React from 'react';
import clsx from 'clsx';
import { IProps } from './SkipToContent.interface';
import Button from '@/elements/Button/Button.component';
import './SkipToContent.styles.css';

const SkipToContent: React.FC<IProps> = ({ className, links = [] }) => {
    if (!links || links.length === 0) {
        return null;
    }

    return (
        <section className={clsx('skipToContent', className)}>
            {links.map((link, index) => (
                <Button
                    {...link}
                    as='a'
                    key={`skip-to-content-link-${index}`}

                >
                    {link.children}
                </Button>
            ))}
        </section>
    );
};

export default SkipToContent;
